export type InspectingViewMode = 'accordion' | 'grid';

const STORAGE_KEY = 'seesor.inspecting.viewMode';

export const getStoredInspectingViewMode = (): InspectingViewMode => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'grid' ? 'grid' : 'accordion';
  } catch {
    return 'accordion';
  }
};

export const setStoredInspectingViewMode = (mode: InspectingViewMode): void => {
  try {
    window.localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    // ignore storage errors (e.g. private browsing)
  }
};
